import { useEffect, useState } from "react";
import { Tabs } from "../../../components/Tabs";
import { CurrentType } from "../../../enum/CurrentType";
import { Dates } from "./Dates";
import { VehiclesTires } from "./VehiclesTires";
import { getAppointmentSummary, getAppointmentTirePositions, getStatus, post_UpdateAppointment } from "../../../services/Appointment";
import { getStatusColor } from "../../../utils/functionHelper";
import moment from "moment";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";
import { Tires } from "./Tires";
import { Customer } from "./Customer";
import useAuth from "../../../hook/useAuth";
import { getLocation } from "../../../services/Location";
import { delete_AdditionalServices, getCustomerServices, post_AdditionalServices, put_AdditionalServices } from "../../../services/Services";
import { delete_AppointmentTirePosition, delete_AppointmentTireReservation, delete_AppointmentWheelReservation, post_AppointmentTirePosition, post_AppointmentTireReservation, post_AppointmentWheelReservation, put_AppointmentTireReservation, put_AppointmentWheelReservation } from "../../../services/Tires";
import { post_CreateOrUpdateInvoice } from "../../../services/Invoice";
import { Invoice } from "./Invoice";
import { Payments } from "./Payments";
import { WorkOrder } from "./WorkOrder";
import { inventoryTypes } from "../../../utils/inventoryType";
import { Wheels } from "./Wheels";


const AddServiceForTireChangeTabs = [
    {
        label: "1. Date & Service",
    },
    {
        label: "2. Vehicle Details",
    },
    {
        label: "3. Tires",
    },
    {
        label: "4. Customer",
    },
]

const AddServiceForWheelChangeTabs = [
    {
        label: "1. Date & Service",
    },
    {
        label: "2. Vehicle Details",
    },
    {
        label: "3. Wheels",
    },
    {
        label: "4. Customer",
    },
]

const AddServiceForTireAndWheelChangeTabs = [
    {
        label: "1. Date & Service",
    },
    {
        label: "2. Vehicle Details",
    },
    {
        label: "3. Tires",
    },
    {
        label: "4. Wheels",
    },
    {
        label: "5. Customer",
    },
]


const AddServiceForOtherTabs = [
    {
        label: "1. Date & Service",
    },
    {
        label: "2. Vehicle Details",
    },
    {
        label: "3. Customer",
    },
]

const EditServiceForTireChangeTabs = [
    {
        label: "1. Date & Service",
    },
    {
        label: "2. Vehicle Details",
    },
    {
        label: "3. Tires",
    },
    {
        label: "4. Customer",
    },
    {
        label: "5. Invoice",
    },
    {
        label: "6. Payments",
    },
    {
        label: "7. WorkOrder",
    }
]

const EditServiceForWheelChangeTabs = [
    {
        label: "1. Date & Service",
    },
    {
        label: "2. Vehicle Details",
    },
    {
        label: "3. Wheels",
    },
    {
        label: "4. Customer",
    },
    {
        label: "5. Invoice",
    },
    {
        label: "6. Payments",
    },
    {
        label: "7. WorkOrder",
    }
]

const EditServiceForTireAndWheelChangeTabs = [
    {
        label: "1. Date & Service",
    },
    {
        label: "2. Vehicle Details",
    },
    {
        label: "3. Tires",
    },
    {
        label: "4. Wheels",
    },
    {
        label: "5. Customer",
    },
    {
        label: "6. Invoice",
    },
    {
        label: "7. Payments",
    },
    {
        label: "8. WorkOrder",
    }
]




const EditServiceForTireCanelledOrNoShowTabs = [
    {
        label: "1. Date & Service",
    },
    {
        label: "2. Vehicle Details",
    },
    {
        label: "3. Tires",
    },
    {
        label: "4. Customer",
    },
    {
        label: "5. Invoice",
    }
]

const EditServiceForWheelCanelledOrNoShowTabs = [
    {
        label: "1. Date & Service",
    },
    {
        label: "2. Vehicle Details",
    },
    {
        label: "3. Wheel",
    },
    {
        label: "4. Customer",
    },
    {
        label: "5. Invoice",
    }
]


const EditServiceForTireAndWheelCanelledOrNoShowTabs = [
    {
        label: "1. Date & Service",
    },
    {
        label: "2. Vehicle Details",
    },
    {
        label: "3. Tires",
    },
    {
        label: "4. Wheels",
    },
    {
        label: "5. Customer",
    },
    {
        label: "6. Invoice",
    }
]




const EditServiceForOtherServiceTabs = [
    {
        label: "1. Date & Service",
    },
    {
        label: "2. Vehicle Details",
    },
    {
        label: "3. Customer",
    },
    {
        label: "4. Invoice",
    },
    {
        label: "5. Payments",
    },
    {
        label: "6. WorkOrder",
    }
]

const EditServiceCancelledOrNoShowForOtherServiceTabs = [
    {
        label: "1. Date & Service",
    },
    {
        label: "2. Vehicle Details",
    },
    {
        label: "3. Customer",
    },
    {
        label: "4. Invoice",
    },
]

const EditIsRequestedTabs = [
    {
        label: "1. Date & Service",
    },
    {
        label: "2. Vehicle Details",
    }
]


type TabType = {
    label: string
}

type ServiceStepsLayoutProps = {
    currentType: CurrentType;
    setCurrentType: (value: CurrentType) => void;
    _primaryKey: number;
}

export const ServiceStepsLayout = ({ currentType, setCurrentType, _primaryKey }: ServiceStepsLayoutProps) => {
    const { auth }: any = useAuth();
    const [primaryKey, setPrimaryKey] = useState<number>(0);
    const [tabs, setTabs] = useState<TabType[]>(AddServiceForOtherTabs);
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [status, setStatus] = useState<any[]>([]);
    const [appointmentData, setAppointmentData] = useState<any>(null);
    const [locationId, setLocationId] = useState<number>(0);
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const [locationAddress, setLoactionAddress] = useState<string>("");
    const [locationLink, setLoactionLink] = useState<string>("");
    const [appointmentDataRefresh, setAppointmentDataRefresh] = useState<boolean>(false);
    const [isTireChangeService, setIsTireChangeService] = useState<boolean>(false);
    const [isWheelChangeService, setIsWheelChangeService] = useState<boolean>(false);
    //Dates
    const [serviceDate, setServiceDate] = useState(moment().format("YYYY-MM-DD"));
    const [serviceTime, setServiceTime] = useState<string>(moment().format('HH:mm'))// HH:mm
    //service
    const [allServices, setAllServices] = useState<any[]>([]);
    //vehicle
    const [vehicleId, setVehicleId] = useState<number | null>(null);
    const [vehicleYear, setVehicleYear] = useState<number | null>(null);
    const [brandId, setBrandId] = useState<number | null>(null);
    const [modelId, setModelId] = useState<number | null>(null);
    const [brandValue, setBrandValue] = useState<string>("");
    const [modelValue, setModelValue] = useState<string>("");
    const [selectedIsCantFindIt, setSelectedIsCantFindIt] = useState<boolean>(false);
    //Trim
    const [vehicleTrimID, setVehicleTrimID] = useState<number | null>(null);
    const [vehicleTrimLabel, setVehicleTrimLabel] = useState<string>("");
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    //Tire
    const [selectedTireSizeId, setSelectedTireSizeId] = useState<null | number>(null);
    const [selectedTireWidth, setSelectedTireWidth] = useState<string>("");
    const [selectedTireRatio, setSelectedTireRatio] = useState<string>("");
    const [selectedTireDiameter, setSelectedTireDiameter] = useState<string>("");
    //Rear Tire
    const [selectedIsRearTireSize, setSelectedIsRearTireSize] = useState<boolean>(false);
    const [selectedRearTireSizeId, setSelectedRearTireSizeId] = useState<null | number>(null);
    const [selectedRearTireWidth, setSelectedRearTireWidth] = useState<string>("");
    const [selectedRearTireRatio, setSelectedRearTireRatio] = useState<string>("");
    const [selectedRearTireDiameter, setSelectedRearTireDiameter] = useState<string>("");
    //Requested Tire Size
    const [selectedIsRequestedTireSize, setSelectedIsRequestedTireSize] = useState<boolean>(false);
    const [selectedRequestedTireWidth, setSelectedRequestedTireWidth] = useState<string>("");
    const [selectedRequestedTireRatio, setSelectedRequestedTireRatio] = useState<string>("");
    const [selectedRequestedTireDiameter, setSelectedRequestedTireDiameter] = useState<string>("");

    const [selectedIsComercial, setSelectedIsComercial] = useState<boolean>(false);
    const [selectedTireCount, setSelectedTireCount] = useState<number>(1);
    const [selectedPositions, setSelectedPositions] = useState<any[]>([]);
    //for compareing
    const [prevSelectedPositions, setPrevSelectedPositions] = useState<any[]>([]);
    //TiresInventory
    const [selectedTireProducts, setSelectedTireProducts] = useState<any[]>([]);
    //WheelsInventory
    const [selectedWheelProducts, setSelectedWheelProducts] = useState<any[]>([]);
    //Customer
    const [customerId, setCustomerId] = useState<null | number>(null);
    const [customerFirstName, setCustomerFirstName] = useState<string>("");
    const [customerLastName, setCustomerLastName] = useState<string>("");
    const [customerEmail, setCustomerEmail] = useState<string>("");
    const [customerPhoneNumber, setCustomerPhoneNumber] = useState<string>("");
    const [customerAdditionalInfo, setCustomerAdditionalInfo] = useState<string>("");
    //Invoice
    const [invoiceId, setInvoiceId] = useState<null | number>(null);
    //WorkOrder
    const [workOrderId, setWorkOrderId] = useState<null | number>(null);
    //warning message on tab click
    const [datesWarning, setDatesWarning] = useState<boolean>(false);
    const [tiresWarning, setTiresWarning] = useState<boolean>(false);
    const [otherWarning, setOtherWarning] = useState<boolean>(false);

    useEffect(() => {
        const istireChangeService = allServices.some(
            (s: any) => s.inventoryType === inventoryTypes[1]?.id
        );

        const iswheelChangeService = allServices.some(
            (s: any) => s.inventoryType === inventoryTypes[2]?.id
        );

        if (istireChangeService || iswheelChangeService) {
            if (istireChangeService && !iswheelChangeService) {
                setIsTireChangeService(true);
                setIsWheelChangeService(false);
            }
            else if (!istireChangeService && iswheelChangeService) {
                setIsTireChangeService(false);
                setIsWheelChangeService(true);
            }
            else {
                setIsTireChangeService(true);
                setIsWheelChangeService(true);
            }

            if ((appointmentData?.status === "NoShow" || appointmentData?.status === "Cancelled") && currentType === CurrentType.EDIT) {
                if (istireChangeService && !iswheelChangeService) {
                    setTabs(EditServiceForTireCanelledOrNoShowTabs);
                }
                else if (iswheelChangeService && !istireChangeService) {
                    setTabs(EditServiceForWheelCanelledOrNoShowTabs);
                }
                else {
                    setTabs(EditServiceForTireAndWheelCanelledOrNoShowTabs);
                }

            }
            if (appointmentData?.customerRequestedTireSize && currentType === CurrentType.EDIT) {
                setTabs(EditIsRequestedTabs);
            }
            else if (currentType === CurrentType.EDIT) {
                if (istireChangeService && !iswheelChangeService) {
                    setTabs(EditServiceForTireChangeTabs);
                }
                else if (iswheelChangeService && !istireChangeService) {
                    setTabs(EditServiceForWheelChangeTabs);
                }
                else {
                    setTabs(EditServiceForTireAndWheelChangeTabs);
                }

            }
            else {
                if (istireChangeService && !iswheelChangeService) {
                    setTabs(AddServiceForTireChangeTabs);
                }
                else if (iswheelChangeService && !istireChangeService) {
                    setTabs(AddServiceForWheelChangeTabs);
                }
                else {
                    setTabs(AddServiceForTireAndWheelChangeTabs);
                }

            }
        }
        else {
            setIsTireChangeService(false);
            setIsWheelChangeService(false);
            if ((appointmentData?.status === "NoShow" || appointmentData?.status === "Cancelled") && currentType === CurrentType.EDIT) {
                setTabs(EditServiceCancelledOrNoShowForOtherServiceTabs);
            }
            else if (currentType === CurrentType.EDIT) {
                setTabs(EditServiceForOtherServiceTabs);
            }
            else {
                setTabs(AddServiceForOtherTabs);
            }
        }

    }, [allServices, currentType, appointmentData])


    useEffect(() => {
        getLocation()
            .then((data) => {
                setLocationOptions(() => data?.map((loc: any) => {
                    return {
                        value: loc?.id,
                        label: loc?.locationName,
                        address: `${loc?.street}, ${loc?.city}, ${loc?.state} ${loc?.zipCode}, ${loc?.country}`,
                        locationlink: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${loc?.street}, ${loc?.city}, ${loc?.state} ${loc?.zipCode}`)}`
                    }
                }))
                if (currentType === CurrentType.ADD) {
                    setLocationId(data[0]?.id);
                    setLoactionAddress(`${data[0]?.street}, ${data[0]?.city}, ${data[0]?.state} ${data[0]?.zipCode}, ${data[0]?.country}`);
                    setLoactionLink(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${data[0]?.street}, ${data[0]?.city}, ${data[0]?.state} ${data[0]?.zipCode}`)}`)
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }, [currentType])

    useEffect(() => {
        getStatus("Appointment")
            .then((data) => {
                setStatus(() => data?.map((status: any) => {
                    return {
                        id: status.statusID,
                        statusValue: status.statusValue
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])


    useEffect(() => {
        if (_primaryKey > 0) {
            setPrimaryKey(_primaryKey)
        }
    }, [_primaryKey])


    useEffect(() => {
        if (primaryKey > 0) {
            setCurrentType(CurrentType.EDIT)
            getAppointmentData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [primaryKey])

    const getAppointmentData = () => {
        setAppointmentDataRefresh(false);
        setPleaseWaitPopup(true);
        getAppointmentSummary(primaryKey)
            .then((data) => {
                getAppointmentSelectedTirePositions();
                setAppointmentData(data)
                setAppointmentDataRefresh(true);
                setPleaseWaitPopup(false);
            })
            .catch((error) => {
                console.error(error)
                setAppointmentDataRefresh(false);
            })
    }

    const getAppointmentSelectedTirePositions = () => {
        getAppointmentTirePositions(primaryKey)
            .then((data) => {
                setPrevSelectedPositions(() => data?.map((pos: any) => {
                    return {
                        id: pos.id,
                        position: pos.position,
                        serviceId: pos?.serviceId
                    }
                }))
                setSelectedPositions(() => data?.map((pos: any) => {
                    return {
                        id: pos.id,
                        position: pos.position,
                        serviceId: pos?.serviceId
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
            })
    }

    useEffect(() => {
        if (locationOptions.length > 0 && locationId > 0 && currentType === CurrentType.EDIT) {
            const locationItem = locationOptions?.find((item: any) => item?.value === locationId);
            setLoactionAddress(locationItem?.address);
            setLoactionLink(locationItem?.locationlink)

        }
    }, [locationOptions, locationId, currentType])

    useEffect(() => {
        if (!appointmentDataRefresh || !appointmentData || primaryKey <= 0) return;
        getCustomerServices()
            .then((data) => {
                setServiceDate(moment(new Date(appointmentData.appointmentDate)).format("YYYY-MM-DD"));
                setServiceTime(appointmentData.timeSlot);
                if (appointmentData?.location) {
                    setLocationId(appointmentData?.location?.id)
                }

                const servicesData: any[] = [];

                if (appointmentData?.service?.serviceID) {
                    servicesData.push({
                        id: appointmentData.service.serviceID,
                        requiresTireCount: appointmentData.service.requiresTireCount,
                        price: appointmentData.service.unitPrice,
                        serviceName: appointmentData.service.serviceName,
                        inventoryType: data?.find((s: any) => s?.serviceID === appointmentData.service.serviceID)?.inventoryType,
                        quantity: appointmentData.service.quantity
                    });
                }

                if (appointmentData?.additionalServices?.length) {
                    appointmentData.additionalServices.forEach((item: any) => {
                        if (item?.serviceID) {
                            servicesData.push({
                                id: item?.serviceID,
                                additionalAppointmentServiceID: item?.additionalAppointmentServiceID,
                                requiresTireCount: item?.requiresTireCount,
                                price: item?.unitPrice,
                                serviceName: item?.serviceName,
                                inventoryType: data?.find((s: any) => s?.serviceID === item.serviceID)?.inventoryType,
                                quantity: item?.quantity
                            });
                        }
                    });
                }

                setAllServices(Array.from(new Set(servicesData)));
                if (appointmentData?.vehicle) {
                    if (appointmentData?.vehicle?.year > 0 && appointmentData?.vehicle?.make && appointmentData?.vehicle?.model) {
                        setVehicleId(appointmentData?.vehicle?.vehicleID);
                        setVehicleYear(appointmentData?.vehicle?.year);
                        setBrandValue(appointmentData?.vehicle?.make);
                        setBrandId(appointmentData?.vehicle?.makeID);
                        setModelId(appointmentData?.vehicle?.modelID)
                        setModelValue(appointmentData?.vehicle?.model);
                    }
                    else {
                        setSelectedIsCantFindIt(true);
                    }
                    setSelectedIsComercial(appointmentData?.vehicle?.isCommercial);
                }

                if (appointmentData?.vehicleTrim) {
                    setVehicleTrimID(appointmentData?.vehicleTrim?.vehicleTrimID);
                    setVehicleTrimLabel(appointmentData?.vehicleTrim?.trimName)
                }

                if (appointmentData?.tireFitment && appointmentData?.tireFitment?.tireFitmentID > 0) {
                    setSelectedTireSizeId(appointmentData?.tireFitment?.tireFitmentID);
                    setSelectedTireWidth(String(appointmentData?.tireFitment?.metricWidth));
                    setSelectedTireRatio(String(appointmentData?.tireFitment?.aspectRatio));
                    setSelectedTireDiameter(String(appointmentData?.tireFitment?.diameter));
                }

                if (appointmentData?.rearTireFitment && appointmentData?.rearTireFitment?.tireFitmentID > 0) {
                    setSelectedIsRearTireSize(true);
                    setSelectedRearTireSizeId(appointmentData?.rearTireFitment?.tireFitmentID);
                    setSelectedRearTireWidth(String(appointmentData?.rearTireFitment?.metricWidth));
                    setSelectedRearTireRatio(String(appointmentData?.rearTireFitment?.aspectRatio));
                    setSelectedRearTireDiameter(String(appointmentData?.rearTireFitment?.diameter));
                }

                if (appointmentData?.customerRequestedTireSize && appointmentData?.customerRequestedTireSize?.requestId > 0) {
                    setSelectedIsRequestedTireSize(true);
                    setSelectedRequestedTireWidth(String(appointmentData?.customerRequestedTireSize?.metricWidth));
                    setSelectedRequestedTireRatio(String(appointmentData?.customerRequestedTireSize?.aspectRatio));
                    setSelectedRequestedTireDiameter(String(appointmentData?.customerRequestedTireSize?.diameter));
                }

                if (appointmentData?.tireCount > 0) {
                    setSelectedTireCount(appointmentData?.tireCount)
                }

                if (appointmentData?.appointmentTireReservation && appointmentData?.appointmentTireReservation?.length > 0) {
                    setSelectedTireProducts(() => appointmentData?.appointmentTireReservation?.map((item: any) => {
                        return {
                            reservationId: item?.reservationId,
                            appointmentId: primaryKey,
                            tireProductId: item?.tireProductId,
                            locationId: locationId,
                            quantity: item?.quantity
                        }
                    }))

                }

                if (appointmentData?.appointmentWheelReservation && appointmentData?.appointmentWheelReservation?.length > 0) {
                    setSelectedWheelProducts(() => appointmentData?.appointmentWheelReservation?.map((item: any) => {
                        return {
                            reservationId: item?.reservationId,
                            appointmentId: primaryKey,
                            wheelProductId: item?.wheelProductId,
                            locationId: locationId,
                            quantity: item?.quantity
                        }
                    }))

                }


                if (appointmentData?.customer && appointmentData?.customer?.customerID) {
                    setCustomerId(appointmentData?.customer?.customerID);
                    setCustomerFirstName(appointmentData?.customer?.firstName);
                    setCustomerLastName(appointmentData?.customer?.lastName);
                    setCustomerEmail(appointmentData?.customer?.email);
                    setCustomerPhoneNumber(appointmentData?.customer?.phone);
                    setCustomerAdditionalInfo(appointmentData?.customer?.additionalInformation);
                }

                if (appointmentData?.invoice && appointmentData?.invoice?.invoiceID) {
                    setInvoiceId(appointmentData?.invoice?.invoiceID);
                }

                if (appointmentData?.workOrder && appointmentData?.workOrder?.workOrderID) {
                    setWorkOrderId(appointmentData?.workOrder?.workOrderID);
                }

                setAppointmentDataRefresh(false);
            }).catch((error) => {
                console.error(error);
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentDataRefresh, appointmentData, primaryKey]);

    const validateServices = (isSelected: boolean) => {
        for (const service of allServices) {

            const selectedCount = selectedPositions.filter(
                pos => pos.serviceId === service.id
            ).length;

            if (service.requiresTireCount) {

                if ((!service.quantity || service.quantity <= 0) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return false;
                }

                if ((selectedCount !== service.quantity) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return false;
                }
            }

        }



        return true;
    };

    const handleTabChange = (index: number, tab: any, isSelected: boolean = false) => {
        switch (index) {
            case 0:
                setActiveIndex(index);
                setDatesWarning(false)
                setTiresWarning(false);
                setOtherWarning(false);
                break;
            case 1:
                if ((serviceDate && serviceTime && allServices.length > 0) || isSelected) {
                    setActiveIndex(index);
                    setDatesWarning(false);
                }
                else {
                    setDatesWarning(true);
                    setTiresWarning(false);
                    setOtherWarning(false);
                }
                break;
            case 2:

                if ((!selectedIsCantFindIt && (!vehicleYear || !brandId || !modelId) && (isTireChangeService || isWheelChangeService)) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return;
                }

                if ((!selectedIsCantFindIt && (!vehicleYear || !brandId || !modelId) && !isTireChangeService && !isWheelChangeService) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return;
                }


                if (((isTireChangeService || isWheelChangeService) && !selectedIsCantFindIt && vehicleYear && brandId && modelId && !selectedIsRearTireSize && !selectedTireSizeId && !selectedIsRequestedTireSize) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return;
                }

                if (((isTireChangeService || isWheelChangeService) && !selectedIsCantFindIt && vehicleYear && brandId && modelId && selectedIsRearTireSize && !selectedTireSizeId && !selectedIsRequestedTireSize) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return;
                }

                if (((isTireChangeService || isWheelChangeService) && selectedIsCantFindIt && !selectedIsRearTireSize && !selectedIsRequestedTireSize && !selectedTireSizeId) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return;
                }

                if (((isTireChangeService || isWheelChangeService) && selectedIsCantFindIt && selectedIsRearTireSize && !selectedIsRequestedTireSize && !selectedRearTireSizeId) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return;
                }

                if (((isTireChangeService || isWheelChangeService) && !selectedIsCantFindIt && !selectedIsRearTireSize && !selectedIsRequestedTireSize && !selectedTireSizeId) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return;
                }

                if (((isTireChangeService || isWheelChangeService) && !selectedIsCantFindIt && selectedIsRearTireSize && !selectedIsRequestedTireSize && !selectedRearTireSizeId) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return;
                }

                if (((isTireChangeService || isWheelChangeService) && selectedIsRequestedTireSize && (!selectedRequestedTireWidth.length || !selectedRequestedTireRatio.length || !selectedRequestedTireDiameter.length)) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return;
                }



                if (((isTireChangeService || isWheelChangeService) && !selectedIsRearTireSize && selectedTireSizeId && !selectedIsRequestedTireSize && (!selectedTireWidth.length || !selectedTireRatio.length || !selectedTireDiameter.length)) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return;
                }


                if (((isTireChangeService || isWheelChangeService) && selectedIsRearTireSize && selectedTireSizeId && selectedRearTireSizeId && !selectedIsRequestedTireSize && (!selectedTireWidth.length || !selectedTireRatio.length || !selectedTireDiameter.length || !selectedRearTireWidth.length || !selectedRearTireRatio.length || !selectedRearTireDiameter.length)) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return;
                }


                if (((isTireChangeService || isWheelChangeService) && selectedIsRearTireSize && !selectedTireSizeId && selectedRearTireSizeId && !selectedIsRequestedTireSize && (!selectedRearTireWidth.length || !selectedRearTireRatio.length || !selectedRearTireDiameter.length)) && !isSelected) {
                    setDatesWarning(false);
                    setTiresWarning(false);
                    setOtherWarning(true);
                    return;
                }

                const isValid = validateServices(isSelected);
                if (!isValid) return;

                setActiveIndex(index)
                setDatesWarning(false);
                setTiresWarning(false);
                setOtherWarning(false);
                break;
            case 3:
                if (isTireChangeService || isWheelChangeService) {
                    setActiveIndex(index);
                    setOtherWarning(false);
                    setDatesWarning(false);
                    setTiresWarning(false);
                }
                else if (!isTireChangeService && !isWheelChangeService) {
                    if (appointmentData?.invoice) {
                        setActiveIndex(index);
                        setOtherWarning(false);
                        setDatesWarning(false);
                        setTiresWarning(false);
                    }
                    else {
                        setOtherWarning(true);
                    }
                }
                break;
            case 4:
                if (appointmentData?.invoice) {
                    setActiveIndex(index);
                    setOtherWarning(false);
                    setDatesWarning(false);
                    setTiresWarning(false);
                }
                else {
                    setOtherWarning(true);
                }
                break;
            case 5:
                if (isTireChangeService || isWheelChangeService) {
                    if (appointmentData?.invoice) {
                        setActiveIndex(index);
                        setOtherWarning(false);
                        setDatesWarning(false);
                        setTiresWarning(false);
                    }
                    else {
                        setOtherWarning(true);
                    }
                }
                else {
                    if (!appointmentData?.workOrder) {
                        setOtherWarning(true);
                    }
                    else {
                        setActiveIndex(index);
                        setOtherWarning(false);
                        setDatesWarning(false);
                        setTiresWarning(false);
                    }
                    break;

                }
                break;
            case 6:
                if (!appointmentData?.invoice) {
                    setOtherWarning(true);
                }
                else {
                    setActiveIndex(index);
                    setOtherWarning(false);
                    setDatesWarning(false);
                    setTiresWarning(false);
                }
                break;
            case 7:
                if (!appointmentData?.workOrder) {
                    setOtherWarning(true);
                }
                else {
                    setActiveIndex(index);
                    setOtherWarning(false);
                    setDatesWarning(false);
                    setTiresWarning(false);
                }
                break;


        }

    }

    const goToNextStep = () => {
        const currentIndex = activeIndex;
        setActiveIndex(currentIndex + 1)
        handleTabChange(currentIndex + 1, tabs[currentIndex + 1], true);
    }


    const getDataFromDateAndService = (
        inputServiceDate: string,
        inputServiceTime: string,
        selectedServices: number[],
        serviceLocationId: number,
        serviceLocationAddress: string,
        serviceLocationLink: string
    ) => {
        if (!selectedServices?.some((s: any) => s.inventoryType === inventoryTypes?.find((item: any) => item?.label === "Tire")?.id || s.inventoryType === inventoryTypes?.find((item: any) => item?.label === "Wheel")?.id
        )) {
            setVehicleTrimID(null);
            setVehicleTrimLabel("");
            setSelectedTireSizeId(null);
            setSelectedTireWidth("");
            setSelectedTireRatio("");
            setSelectedTireDiameter("");
            setSelectedRearTireSizeId(null);
            setSelectedRearTireWidth("");
            setSelectedRearTireRatio("");
            setSelectedRearTireDiameter("");
            setSelectedIsRequestedTireSize(false);
            setSelectedRequestedTireWidth("");
            setSelectedRequestedTireRatio("");
            setSelectedRequestedTireDiameter("");
        }
        setServiceDate(inputServiceDate);
        setServiceTime(inputServiceTime);
        setAllServices(selectedServices);
        setLocationId(serviceLocationId);
        setLoactionAddress(serviceLocationAddress);
        setLoactionLink(serviceLocationLink);
    }

    const getDataFromVehicles = (
        selectedVehicleYear: number | null,
        selectedBrandId: number | null,
        selectedModelId: number | null,
        selectedBrandValue: string,
        selectedModelValue: string,
        vehicleTrimID: number | null,
        vehicleTrimLabel: string,
        selectedTireSizeId: null | number,
        selectedTireWidth: string,
        selectedTireRatio: string,
        selectedTireDiameter: string,
        selectedRearTireSizeId: null | number,
        selectedRearTireWidth: string,
        selectedRearTireRatio: string,
        selectedRearTireDiameter: string,
        selectedIsComercial: boolean,
        selectedTireCount: number,
        selectedIsRequestedTireSize: boolean,
        selectedRequestedTireWidth: string,
        selectedRequestedTireRatio: string,
        selectedRequestedTireDiameter: string,
        selectedPositions: number[],
        selectedServices: any[],
        selectedIsCantFindit: boolean,
        selectedIsRearTireSize: boolean
    ) => {
        setVehicleYear(selectedVehicleYear);
        setBrandId(selectedBrandId);
        setModelId(selectedModelId);
        setBrandValue(selectedBrandValue);
        setModelValue(selectedModelValue);
        setVehicleTrimID(vehicleTrimID);
        setVehicleTrimLabel(vehicleTrimLabel);
        setSelectedTireSizeId(selectedTireSizeId);
        setSelectedTireWidth(selectedTireWidth);
        setSelectedTireRatio(selectedTireRatio);
        setSelectedTireDiameter(selectedTireDiameter);
        setSelectedRearTireSizeId(selectedRearTireSizeId);
        setSelectedRearTireWidth(selectedRearTireWidth);
        setSelectedRearTireRatio(selectedRearTireRatio);
        setSelectedRearTireDiameter(selectedRearTireDiameter);
        setSelectedIsRequestedTireSize(selectedIsRequestedTireSize);
        setSelectedRequestedTireWidth(selectedRequestedTireWidth);
        setSelectedRequestedTireRatio(selectedRequestedTireRatio);
        setSelectedRequestedTireDiameter(selectedRequestedTireDiameter);
        setSelectedIsComercial(selectedIsComercial);
        setSelectedTireCount(selectedTireCount);
        setSelectedPositions(selectedPositions);
        setAllServices(selectedServices);
        setSelectedIsCantFindIt(selectedIsCantFindit);
        setSelectedIsRearTireSize(selectedIsRearTireSize);
    }

    const getDataFromTires = (selectedTires: any[]) => {
        setSelectedTireProducts(selectedTires)
    }

    const getDataFromWheels = (selectedWheels: any[]) => {
        setSelectedWheelProducts(selectedWheels)
    }

    const getDataFromCustomer = (firstName: string, lastName: string, email: string, phoneNumber: string, additionalInfo: string) => {
        if (primaryKey && primaryKey > 0) {
            updateAppointment(appointmentData?.statusId, firstName, lastName, email, phoneNumber, additionalInfo);
        }
        else {
            const statusId = status?.filter((item: any) => item?.statusValue === "Scheduled")[0]?.id;
            createAppointment(statusId, firstName, lastName, email, phoneNumber, additionalInfo);
        }

    }


    const updateAppointmentStatusCustomer = (customerStatus: string) => {
        if (customerStatus === "noshow") {
            const statusId = status?.filter((item: any) => item?.statusValue === "NoShow")[0]?.id;
            updateAppointmentStatus(statusId);
        }
        else if (customerStatus === "cancel") {
            const statusId = status?.filter((item: any) => item?.statusValue === "Cancelled")[0]?.id;
            updateAppointmentStatus(statusId);
        }
        else if (customerStatus === "scheduled") {
            const statusId = status?.filter((item: any) => item?.statusValue === "Scheduled")[0]?.id;
            updateAppointmentStatus(statusId);
        }
    }


    const updateAppointment = async (statusId: number, firstName: string, lastName: string, email: string, phoneNumber: string, additionalInfo: string) => {
        setPleaseWaitPopup(true)
        const requiresTireCount: boolean = allServices.find(
            (s: any) => s.id === appointmentData?.service?.serviceID
        )?.requiresTireCount;
        const serviceId = allServices.some(
            (s: any) => s.id === appointmentData?.service?.serviceID
        );

        await post_UpdateAppointment({
            appointmentId: primaryKey,
            appointmentDate: serviceDate,
            timeSlot: serviceTime,
            tireCount: requiresTireCount ? allServices.find(
                (s: any) => s.id === appointmentData?.service?.serviceID
            )?.quantity : 1,
            statusId,
            serviceID: serviceId ? appointmentData?.service?.serviceID : allServices[0]?.id,
            customerId: customerId,
            locationId: locationId,
            customer: {
                firstName: firstName ? firstName : customerFirstName,
                lastName: lastName ? lastName : customerLastName,
                phone: phoneNumber ? phoneNumber : customerPhoneNumber,
                email: email ? email : customerEmail,
                address: "",
                city: "",
                state: "",
                zipCode: "",
                additionalInformation: additionalInfo ? additionalInfo : customerAdditionalInfo
            },
            vehicle: {
                makeID: brandId,
                modelID: modelId,
                vehicleYear: vehicleYear,
                vin: "",
                tireSize: "",
                wheelSize: "",
                vehicleTrimID: vehicleTrimID ? vehicleTrimID > 0 ? vehicleTrimID : null : null,
                tireFitmentID: !selectedIsRequestedTireSize ? selectedTireSizeId : null,
                rearTireFitmentID: !selectedIsRequestedTireSize ? selectedRearTireSizeId : null,
                isCommercial: selectedIsComercial,
                isRequestForTireSize: selectedIsRequestedTireSize,
                metricWidth: selectedRearTireWidth,
                aspectRatio: selectedRearTireRatio,
                diameter: selectedRearTireDiameter
            }
        }, auth?.id)
            .then(async (res) => {
                const apiCalls: Promise<any>[] = [];
                const newAdditionalServices =
                    allServices
                        ?.slice(1)
                        ?.filter(service =>
                            !appointmentData?.additionalServices?.some(
                                (s: any) => s.serviceID === service.id
                            )
                        ) || [];

                const updateAdditionalService =
                    allServices.filter(service => {
                        const existing = appointmentData?.additionalServices.find(
                            (s: any) => s.serviceID === service.id
                        );

                        return (
                            existing &&
                            existing.reservationId > 0 &&
                            Number(existing.quantity) !== Number(service.quantity)
                        );
                    });


                const deleteAdditionalServices =
                    appointmentData?.additionalServices
                        ?.filter((service: any) =>
                            service.additionalAppointmentServiceID > 0 &&
                            !allServices
                                ?.slice(1)
                                ?.some(s => s.id === service.serviceID)
                        ) || [];

                if (newAdditionalServices.length > 0) {
                    apiCalls.push(addAdditionalServices(newAdditionalServices));
                }

                if (updateAdditionalService.length > 0) {
                    apiCalls.push(updateAdditionalServices(updateAdditionalService));
                }

                if (deleteAdditionalServices.length > 0) {
                    apiCalls.push(deleteAdditionalService(deleteAdditionalServices));
                }


                if (isTireChangeService && selectedTireProducts.length > 0) {
                    const existingTires =
                        appointmentData?.appointmentTireReservation || [];
                    const newSelectedTires =
                        selectedTireProducts?.filter(tire =>
                            !existingTires?.some(
                                (t: any) => t.tireProductId === tire.tireProductId
                            )
                        ) || [];
                    const deleteSelectedTires =
                        existingTires?.filter((tire: any) =>
                            tire.reservationId > 0 &&
                            !selectedTireProducts?.some(
                                t => t.tireProductId === tire.tireProductId
                            )
                        ) || [];
                    const updateSelectedTires =
                        selectedTireProducts.filter(tire => {
                            const existing = existingTires.find(
                                (t: any) => t.tireProductId === tire.tireProductId
                            );

                            return (
                                existing &&
                                existing.reservationId > 0 &&
                                Number(existing.quantity) !== Number(tire.quantity)
                            );
                        });
                    if (newSelectedTires?.length > 0) {
                        apiCalls.push(addAppointmentTiresProduct(newSelectedTires));
                    }

                    if (deleteSelectedTires?.length > 0) {
                        apiCalls.push(deleteAppointmentTiresProduct(deleteSelectedTires));
                    }

                    if (updateSelectedTires?.length > 0) {
                        apiCalls.push(updateAppointmentTiresProduct(updateSelectedTires));
                    }
                }
                else if (!isTireChangeService && appointmentData?.appointmentTireReservation.length > 0) {
                    apiCalls.push(deleteAppointmentTiresProduct(appointmentData?.appointmentTireReservation));
                }

                if (isWheelChangeService && selectedWheelProducts.length > 0) {
                    const existingWheels =
                        appointmentData?.appointmentWheelReservation || [];
                    const newSelectedWheels =
                        selectedWheelProducts?.filter(wheel =>
                            !existingWheels?.some(
                                (t: any) => t.wheelProductId === wheel.wheelProductId
                            )
                        ) || [];
                    const deleteSelectedWheels =
                        existingWheels?.filter((wheel: any) =>
                            wheel.reservationId > 0 &&
                            !selectedWheelProducts?.some(
                                t => t.wheelProductId === wheel.wheelProductId
                            )
                        ) || [];
                    const updateSelectedWheels =
                        selectedTireProducts.filter(wheel => {
                            const existing = existingWheels.find(
                                (t: any) => t.wheelProductId === wheel.wheelProductId
                            );

                            return (
                                existing &&
                                existing.reservationId > 0 &&
                                Number(existing.quantity) !== Number(wheel.quantity)
                            );
                        });
                    if (newSelectedWheels?.length > 0) {
                        apiCalls.push(addAppointmentWheelsProduct(newSelectedWheels));
                    }

                    if (deleteSelectedWheels?.length > 0) {
                        apiCalls.push(deleteAppointmentWheelsProduct(deleteSelectedWheels));
                    }

                    if (updateSelectedWheels?.length > 0) {
                        apiCalls.push(updateAppointmentWheelsProduct(updateSelectedWheels));
                    }
                }
                else if (!isWheelChangeService && appointmentData?.appointmentWheelReservation.length > 0) {
                    apiCalls.push(deleteAppointmentWheelsProduct(appointmentData?.appointmentWheelReservation));
                }
                if (selectedPositions.length > 0) {
                    const newSelectedTirePositions =
                        selectedPositions?.filter(pos =>
                            !prevSelectedPositions?.some(
                                (p: any) =>
                                    p.position === pos.position &&
                                    p.serviceId === pos.serviceId
                            )
                        ) || [];

                    const deleteSelectedTirePositions =
                        prevSelectedPositions?.filter(pos =>
                            pos.id > 0 &&
                            !selectedPositions?.some(
                                p =>
                                    p.position === pos.position &&
                                    p.serviceId === pos.serviceId
                            )
                        ) || [];

                    if (newSelectedTirePositions.length > 0) {
                        apiCalls.push(addTirePositions(newSelectedTirePositions));
                    }

                    if (deleteSelectedTirePositions.length > 0) {
                        apiCalls.push(deleteTirePositions(deleteSelectedTirePositions));
                    }
                }

                await Promise.all(apiCalls);

                await updateInvoice();
                goToNextStep();
            })
            .catch((error) => {
                console.error(error)
            })

    }


    const updateAppointmentStatusWorkOrder = (workorderStatus: string) => {
        if (workorderStatus === "inprogress") {
            const statusId = status?.filter((item: any) => item?.statusValue === "InProgress")[0]?.id;
            updateAppointmentStatus(statusId);
        }
        else if (workorderStatus === "queued") {
            const statusId = status?.filter((item: any) => item?.statusValue === "queued")[0]?.id;
            updateAppointmentStatus(statusId);
        }
        else if (workorderStatus === "done") {
            const statusId = status?.filter((item: any) => item?.statusValue === "Done")[0]?.id;
            updateAppointmentStatus(statusId);
        }
    }

    const updateAppointmentPayment = () => {
        const statusId = status?.filter((item: any) => item?.statusValue === "Queued")[0]?.id;
        updateAppointmentStatus(statusId);
    }

    const updateAppointmentStatus = async (statusId: number) => {
        setPleaseWaitPopup(true)
        await post_UpdateAppointment({
            appointmentId: primaryKey,
            appointmentDate: appointmentData?.appointmentDate,
            timeSlot: serviceTime,
            tireCount: appointmentData?.tireCount,
            statusId,
            serviceID: appointmentData?.service?.serviceID,
            customerId: customerId,
            locationId: locationId,
            customer: {
                firstName: customerFirstName,
                lastName: customerLastName,
                phone: customerPhoneNumber,
                email: customerEmail,
                address: "",
                city: "",
                state: "",
                zipCode: "",
                additionalInformation: customerAdditionalInfo
            },
            vehicle: {
                makeID: brandId,
                modelID: modelId,
                vehicleYear: vehicleYear,
                vin: "",
                tireSize: "",
                wheelSize: "",
                vehicleTrimID: vehicleTrimID ? vehicleTrimID > 0 ? vehicleTrimID : null : null,
                tireFitmentID: !selectedIsRequestedTireSize ? selectedTireSizeId : null,
                rearTireFitmentID: !selectedIsRequestedTireSize ? selectedRearTireSizeId : null,
                isCommercial: selectedIsComercial,
                isRequestForTireSize: selectedIsRequestedTireSize,
                metricWidth: selectedRearTireWidth,
                aspectRatio: selectedRearTireRatio,
                diameter: selectedRearTireDiameter
            }
        }, auth?.id)
            .then((res) => {
                getAppointmentData()
            })
            .catch((error) => {
                console.error(error)
            })
    }

    const createAppointment = async (statusId: number, firstName: string, lastName: string, email: string, phoneNumber: string, additionalInfo: string) => {
        setPleaseWaitPopup(true)
        const requiresTireCount: boolean = allServices[0]?.requiresTireCount;
        await post_UpdateAppointment({
            appointmentId: 0,
            appointmentDate: serviceDate,
            timeSlot: serviceTime,
            tireCount: requiresTireCount ? allServices[0]?.quantity : 1,
            statusId,
            serviceID: allServices[0]?.id,
            locationId: locationId,
            customerId: 0,
            vehicleID: 0,
            customer: {
                firstName: firstName ? firstName : customerFirstName,
                lastName: lastName ? lastName : customerLastName,
                phone: phoneNumber ? phoneNumber : customerPhoneNumber,
                email: email ? email : customerEmail,
                address: "",
                city: "",
                state: "",
                zipCode: "",
                additionalInformation: additionalInfo ? additionalInfo : customerAdditionalInfo
            },
            vehicle: {
                makeID: brandId,
                modelID: modelId,
                vehicleYear: vehicleYear,
                vin: "",
                tireSize: "",
                wheelSize: "",
                vehicleTrimID: vehicleTrimID ? vehicleTrimID > 0 ? vehicleTrimID : null : null,
                tireFitmentID: !selectedIsRequestedTireSize ? selectedTireSizeId : null,
                rearTireFitmentID: !selectedIsRequestedTireSize ? selectedRearTireSizeId : null,
                isCommercial: selectedIsComercial,
                isRequestForTireSize: selectedIsRequestedTireSize,
                metricWidth: selectedRearTireWidth,
                aspectRatio: selectedRearTireRatio,
                diameter: selectedRearTireDiameter
            }
        }, auth?.id)
            .then(async (id) => {
                const apiCalls: Promise<any>[] = [];
                if (allServices.length > 0) {
                    apiCalls.push(addAdditionalServices(allServices.splice(1), id))
                }

                if (isTireChangeService && selectedTireProducts.length > 0) {
                    apiCalls.push(addAppointmentTiresProduct(selectedTireProducts, id));
                }

                if (isWheelChangeService && selectedWheelProducts.length > 0) {
                    apiCalls.push(addAppointmentWheelsProduct(selectedWheelProducts, id));
                }

                if (selectedPositions.length > 0) {
                    apiCalls.push(addTirePositions(selectedPositions, id));
                }

                await Promise.all(apiCalls);
                updateInvoice(id);
            })
            .catch((error) => {
                console.error(error)
            })


    }

    const addAdditionalServices = async (additionalServices: any[], id?: number) => {
        try {
            await Promise.all(
                additionalServices.map((service: any) => post_AdditionalServices({
                    appointmentID: !primaryKey && id ? id : primaryKey,
                    serviceID: service?.id,
                    quantity: service?.quantity
                }, auth?.id))
            );
        } catch (error) {
            console.error("Failed to add one or more services", error);
        }
    }

    const updateAdditionalServices = async (additionalServices: any[], id?: number) => {
        try {
            await Promise.all(
                additionalServices.map((service: any) => put_AdditionalServices({
                    additionalAppointmentServiceID: service?.additionalAppointmentServiceID,
                    appointmentID: !primaryKey && id ? id : primaryKey,
                    serviceID: service?.id,
                    quantity: service?.quantity
                }, auth?.id))
            );
        } catch (error) {
            console.error("Failed to add one or more services", error);
        }
    }

    const deleteAdditionalService = async (additionalServices: any[]) => {
        try {
            await Promise.all(
                additionalServices.map((service: any) => delete_AdditionalServices(service?.additionalAppointmentServiceID, auth?.id))
            );
        } catch (error) {
            console.error("Failed to add one or more services", error);
        }
    }


    const addAppointmentTiresProduct = async (tiresProduct: any[], id?: number) => {
        try {
            await Promise.all(
                tiresProduct.map((tire: any) => post_AppointmentTireReservation({
                    appointmentID: !primaryKey && id ? id : primaryKey,
                    tireProductId: tire?.tireProductId,
                    locationId: tire?.locationId,
                    quantity: tire?.quantity
                }, auth?.id))
            );
        } catch (error) {
            console.error(error);
        }
    }

    const deleteAppointmentTiresProduct = async (tiresProduct: any[]) => {
        try {
            await Promise.all(
                tiresProduct.map((tire: any) => delete_AppointmentTireReservation(tire?.reservationId, auth?.id))
            );
        } catch (error) {
            console.error(error);
        }
    }

    const updateAppointmentTiresProduct = async (tiresProduct: any[]) => {
        try {
            await Promise.all(
                tiresProduct.map((tire: any) => put_AppointmentTireReservation({
                    reservationId: tire?.reservationId,
                    appointmentId: _primaryKey,
                    tireProductId: tire?.tireProductId,
                    locationId: tire?.locationId,
                    quantity: tire?.quantity
                }, auth?.id))
            );
        } catch (error) {
            console.error(error);
        }
    }


    const addAppointmentWheelsProduct = async (wheelsProduct: any[], id?: number) => {
        try {
            await Promise.all(
                wheelsProduct.map((wheel: any) => post_AppointmentWheelReservation({
                    appointmentID: !primaryKey && id ? id : primaryKey,
                    wheelProductId: wheel?.wheelProductId,
                    locationId: wheel?.locationId,
                    quantity: wheel?.quantity
                }, auth?.id))
            );
        } catch (error) {
            console.error(error);
        }
    }

    const deleteAppointmentWheelsProduct = async (wheelsProduct: any[]) => {
        try {
            await Promise.all(
                wheelsProduct.map((wheel: any) => delete_AppointmentWheelReservation(wheel?.reservationId, auth?.id))
            );
        } catch (error) {
            console.error(error);
        }
    }

    const updateAppointmentWheelsProduct = async (wheelsProduct: any[]) => {
        try {
            await Promise.all(
                wheelsProduct.map((wheel: any) => put_AppointmentWheelReservation({
                    reservationId: wheel?.reservationId,
                    appointmentId: _primaryKey,
                    wheelProductId: wheel?.wheelProductId,
                    locationId: wheel?.locationId,
                    quantity: wheel?.quantity
                }, auth?.id))
            );
        } catch (error) {
            console.error(error);
        }
    }



    const addTirePositions = async (tirePositions: any[], id?: number) => {
        try {
            await Promise.all(
                tirePositions?.map((pos: any) => post_AppointmentTirePosition({
                    appointmentID: !primaryKey && id ? id : primaryKey,
                    serviceId: pos?.serviceId,
                    position: pos?.position
                }, auth?.id))
            );
        } catch (error) {
            console.error(error);
        }
    }

    const deleteTirePositions = async (tirePositions: any[]) => {
        try {
            await Promise.all(
                tirePositions?.map((pos: any) => delete_AppointmentTirePosition(pos?.id, auth?.id))
            );
        } catch (error) {
            console.error(error);
        }
    }

    const updateInvoice = async (id?: number) => {
        try {
            await post_CreateOrUpdateInvoice(!primaryKey && id ? id : primaryKey, auth?.id)
            if (!primaryKey && id) {
                setPrimaryKey(id);
            }
            else {
                getAppointmentData()
            }
        } catch (error) {
            console.error(error);
        }
    }


    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto relative`}>
                <div className={`w-full bg-white border rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                    <div className="w-full mt-2 flex items-center justify-start">
                        <Tabs tabs={tabs} onChange={(index, tab) => handleTabChange(index, tab, false)} activeIndex={activeIndex} />
                    </div>
                    {
                        datesWarning && (
                            <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                Please select date, time and service.
                            </p>
                        )
                    }
                    {
                        tiresWarning && (
                            <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                Selected tires quantity must be equal to tire count.
                            </p>
                        )
                    }
                    {
                        otherWarning && (
                            <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                This action is not allowed.
                            </p>
                        )
                    }
                    <div className={`p-2 border-b`}>
                        <div className="mt-4">
                            <h2 className={`text-lg font-semibold`}>
                                {
                                    currentType === CurrentType.ADD ?
                                        "New Service"
                                        : (
                                            <div className="flex items-center gap-2.5">
                                                <span className="inline-block"> Edit Service</span>
                                                <span className="inline-block">-</span>
                                                {appointmentData?.service ? (<span className="inline-block">{appointmentData?.service?.serviceNumber}</span>) : ""}
                                                {appointmentData?.status && (() => {
                                                    const color = getStatusColor(appointmentData.status);

                                                    return (
                                                        <div className="flex items-end h-full">
                                                            <span
                                                                className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}
                                                            >
                                                                {appointmentData.status}
                                                            </span>
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                        )
                                }
                            </h2>
                        </div>
                    </div>
                    <div>
                        {
                            activeIndex === 0 && (
                                <Dates
                                    goToNextPage={() => goToNextStep()}
                                    getDataFromDateAndService={(
                                        inputServiceDate,
                                        inputServiceTime,
                                        selectedServices,
                                        serviceLocationId,
                                        serviceLocationAddress,
                                        serviceLocationLink
                                    ) => {
                                        getDataFromDateAndService(
                                            inputServiceDate,
                                            inputServiceTime,
                                            selectedServices,
                                            serviceLocationId,
                                            serviceLocationAddress,
                                            serviceLocationLink
                                        )
                                    }}

                                    selectedDate={serviceDate}
                                    selectedTime={serviceTime}
                                    allServices={allServices}
                                    primaryKey={primaryKey}
                                    locationId={locationId}
                                    locationOptions={locationOptions}
                                    locationAddress={locationAddress}
                                    locationLink={locationLink}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    status={appointmentData?.status}
                                />
                            )
                        }
                        {
                            activeIndex === 1 && (
                                <VehiclesTires
                                    vehicleId={vehicleId}
                                    selectedVehicleYear={vehicleYear}
                                    selectedBrandId={brandId}
                                    selectedModelId={modelId}
                                    selectedBrandValue={brandValue}
                                    selectedModelValue={modelValue}
                                    primaryKey={primaryKey}
                                    vehicleTrimID={vehicleTrimID}
                                    vehicleTrimLabel={vehicleTrimLabel}
                                    selectedTireSizeId={selectedTireSizeId}
                                    selectedTireWidth={selectedTireWidth}
                                    selectedTireRatio={selectedTireRatio}
                                    selectedTireDiameter={selectedTireDiameter}
                                    selectedRearTireSizeId={selectedRearTireSizeId}
                                    selectedRearTireWidth={selectedRearTireWidth}
                                    selectedRearTireRatio={selectedRearTireRatio}
                                    selectedRearTireDiameter={selectedRearTireDiameter}
                                    selectedIsComercial={selectedIsComercial}
                                    selectedTireCount={selectedTireCount}
                                    selectedIsRequestedTireSize={selectedIsRequestedTireSize}
                                    selectedRequestedTireWidth={selectedRequestedTireWidth}
                                    selectedRequestedTireRatio={selectedRequestedTireRatio}
                                    selectedRequestedTireDiameter={selectedRequestedTireDiameter}
                                    goToNextPage={() => goToNextStep()}
                                    allServices={allServices}
                                    selectedPositions={selectedPositions}
                                    isTireChangeService={isTireChangeService || isWheelChangeService}
                                    selectedIsCantFindIt={selectedIsCantFindIt}
                                    status={appointmentData?.status}
                                    getDataFromVehicles={(
                                        selectedVehicleYear,
                                        selectedBrandId,
                                        selectedModelId,
                                        selectedBrandValue,
                                        selectedModelValue,
                                        vehicleTrimID,
                                        vehicleTrimLabel,
                                        selectedTireSizeId,
                                        selectedTireWidth,
                                        selectedTireRatio,
                                        selectedTireDiameter,
                                        selectedRearTireSizeId,
                                        selectedRearTireWidth,
                                        selectedRearTireRatio,
                                        selectedRearTireDiameter,
                                        selectedIsComercial,
                                        selectedTireCount,
                                        selectedIsRequestedTireSize,
                                        selectedRequestedTireWidth,
                                        selectedRequestedTireRatio,
                                        selectedRequestedTireDiameter,
                                        selectedPositions,
                                        selectedServices,
                                        selectedIsCantFindit,
                                        selectedIsRearTireSize
                                    ) => {
                                        getDataFromVehicles(
                                            selectedVehicleYear,
                                            selectedBrandId,
                                            selectedModelId,
                                            selectedBrandValue,
                                            selectedModelValue,
                                            vehicleTrimID,
                                            vehicleTrimLabel,
                                            selectedTireSizeId,
                                            selectedTireWidth,
                                            selectedTireRatio,
                                            selectedTireDiameter,
                                            selectedRearTireSizeId,
                                            selectedRearTireWidth,
                                            selectedRearTireRatio,
                                            selectedRearTireDiameter,
                                            selectedIsComercial,
                                            selectedTireCount,
                                            selectedIsRequestedTireSize,
                                            selectedRequestedTireWidth,
                                            selectedRequestedTireRatio,
                                            selectedRequestedTireDiameter,
                                            selectedPositions,
                                            selectedServices,
                                            selectedIsCantFindit,
                                            selectedIsRearTireSize
                                        )
                                    }}
                                />
                            )
                        }
                        {
                            (isTireChangeService && !isWheelChangeService && activeIndex === 2) && (
                                <Tires
                                    primaryKey={primaryKey}
                                    selectedTireSizeId={selectedTireSizeId}
                                    selectedIsRearTireSize={selectedIsRearTireSize}
                                    selectedRearTireSizeId={selectedRearTireSizeId}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    selectedTireCount={allServices.find(
                                        (s: any) => s.inventoryType === inventoryTypes[1]?.id
                                    )?.quantity}
                                    selectedTireProducts={selectedTireProducts}
                                    selectedTireWidth={selectedTireWidth}
                                    selectedTireRatio={selectedTireRatio}
                                    selectedTireDiameter={selectedTireDiameter}
                                    selectedRearTireWidth={selectedRearTireWidth}
                                    selectedRearTireRatio={selectedRearTireRatio}
                                    selectedRearTireDiameter={selectedRearTireDiameter}
                                    isCommercial={selectedIsComercial}
                                    status={appointmentData?.status}
                                    locationId={locationId}
                                    goToNextPage={() => goToNextStep()}
                                    getDataFromTires={(
                                        selectedTires
                                    ) => {
                                        getDataFromTires(
                                            selectedTires
                                        )
                                    }}

                                />
                            )
                        }
                        {
                            (isTireChangeService && isWheelChangeService && activeIndex === 2) && (
                                <Tires
                                    primaryKey={primaryKey}
                                    selectedTireSizeId={selectedTireSizeId}
                                    selectedIsRearTireSize={selectedIsRearTireSize}
                                    selectedRearTireSizeId={selectedRearTireSizeId}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    selectedTireCount={allServices.find(
                                        (s: any) => s.inventoryType === inventoryTypes[1]?.id
                                    )?.quantity}
                                    selectedTireProducts={selectedTireProducts}
                                    selectedTireWidth={selectedTireWidth}
                                    selectedTireRatio={selectedTireRatio}
                                    selectedTireDiameter={selectedTireDiameter}
                                    selectedRearTireWidth={selectedRearTireWidth}
                                    selectedRearTireRatio={selectedRearTireRatio}
                                    selectedRearTireDiameter={selectedRearTireDiameter}
                                    isCommercial={selectedIsComercial}
                                    status={appointmentData?.status}
                                    locationId={locationId}
                                    goToNextPage={() => goToNextStep()}
                                    getDataFromTires={(
                                        selectedTires
                                    ) => {
                                        getDataFromTires(
                                            selectedTires
                                        )
                                    }}

                                />
                            )
                        }
                        {
                            (isTireChangeService && !isWheelChangeService && activeIndex === 3) && (
                                <Customer
                                    primaryKey={primaryKey}
                                    customerId={customerId}
                                    setCustomerId={setCustomerId}
                                    customerFirstName={customerFirstName}
                                    setCustomerFirstName={setCustomerFirstName}
                                    customerLastName={customerLastName}
                                    setCustomerLastName={setCustomerLastName}
                                    customerEmail={customerEmail}
                                    setCustomerEmail={setCustomerEmail}
                                    customerPhoneNumber={customerPhoneNumber}
                                    setCustomerPhoneNumber={setCustomerPhoneNumber}
                                    customerAdditionalInfo={customerAdditionalInfo}
                                    status={appointmentData?.status}
                                    goToNextPage={() => goToNextStep()}
                                    updateAppointmentStatusCustomer={(customerStatus: string) => updateAppointmentStatusCustomer(customerStatus)}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    getDataFromCustomer={(
                                        firstName,
                                        lastName,
                                        email,
                                        phoneNumber,
                                        additionalInfo
                                    ) => {
                                        getDataFromCustomer(
                                            firstName,
                                            lastName,
                                            email,
                                            phoneNumber,
                                            additionalInfo
                                        )
                                    }}
                                />
                            )
                        }

                        {
                            (isTireChangeService && isWheelChangeService && activeIndex === 4) && (
                                <Customer
                                    primaryKey={primaryKey}
                                    customerId={customerId}
                                    setCustomerId={setCustomerId}
                                    customerFirstName={customerFirstName}
                                    setCustomerFirstName={setCustomerFirstName}
                                    customerLastName={customerLastName}
                                    setCustomerLastName={setCustomerLastName}
                                    customerEmail={customerEmail}
                                    setCustomerEmail={setCustomerEmail}
                                    customerPhoneNumber={customerPhoneNumber}
                                    setCustomerPhoneNumber={setCustomerPhoneNumber}
                                    customerAdditionalInfo={customerAdditionalInfo}
                                    status={appointmentData?.status}
                                    goToNextPage={() => goToNextStep()}
                                    updateAppointmentStatusCustomer={(customerStatus: string) => updateAppointmentStatusCustomer(customerStatus)}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    getDataFromCustomer={(
                                        firstName,
                                        lastName,
                                        email,
                                        phoneNumber,
                                        additionalInfo
                                    ) => {
                                        getDataFromCustomer(
                                            firstName,
                                            lastName,
                                            email,
                                            phoneNumber,
                                            additionalInfo
                                        )
                                    }}
                                />
                            )
                        }
                        {
                            (isWheelChangeService && !isTireChangeService && activeIndex === 2) && (
                                <Wheels
                                    primaryKey={primaryKey}
                                    selectedTireSizeId={selectedTireSizeId}
                                    selectedIsRearTireSize={selectedIsRearTireSize}
                                    selectedRearTireSizeId={selectedRearTireSizeId}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    selectedTireCount={allServices.find(
                                        (s: any) => s.inventoryType === inventoryTypes[2]?.id
                                    )?.quantity}
                                    selectedWheelProducts={selectedWheelProducts}
                                    selectedTireWidth={selectedTireWidth}
                                    selectedTireRatio={selectedTireRatio}
                                    selectedTireDiameter={selectedTireDiameter}
                                    selectedRearTireWidth={selectedRearTireWidth}
                                    selectedRearTireRatio={selectedRearTireRatio}
                                    selectedRearTireDiameter={selectedRearTireDiameter}
                                    isCommercial={selectedIsComercial}
                                    status={appointmentData?.status}
                                    locationId={locationId}
                                    goToNextPage={() => goToNextStep()}
                                    getDataFromWheels={(
                                        selectedWheels
                                    ) => {
                                        getDataFromWheels(
                                            selectedWheels
                                        )
                                    }}

                                />
                            )
                        }

                        {
                            (isWheelChangeService && isTireChangeService && activeIndex === 3) && (
                                <Wheels
                                    primaryKey={primaryKey}
                                    selectedTireSizeId={selectedTireSizeId}
                                    selectedIsRearTireSize={selectedIsRearTireSize}
                                    selectedRearTireSizeId={selectedRearTireSizeId}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    selectedTireCount={allServices.find(
                                        (s: any) => s.inventoryType === inventoryTypes[2]?.id
                                    )?.quantity}
                                    selectedWheelProducts={selectedWheelProducts}
                                    selectedTireWidth={selectedTireWidth}
                                    selectedTireRatio={selectedTireRatio}
                                    selectedTireDiameter={selectedTireDiameter}
                                    selectedRearTireWidth={selectedRearTireWidth}
                                    selectedRearTireRatio={selectedRearTireRatio}
                                    selectedRearTireDiameter={selectedRearTireDiameter}
                                    isCommercial={selectedIsComercial}
                                    status={appointmentData?.status}
                                    locationId={locationId}
                                    goToNextPage={() => goToNextStep()}
                                    getDataFromWheels={(
                                        selectedWheels
                                    ) => {
                                        getDataFromWheels(
                                            selectedWheels
                                        )
                                    }}

                                />
                            )
                        }

                        {
                            (isWheelChangeService && !isTireChangeService && activeIndex === 3) && (
                                <Customer
                                    primaryKey={primaryKey}
                                    customerId={customerId}
                                    setCustomerId={setCustomerId}
                                    customerFirstName={customerFirstName}
                                    setCustomerFirstName={setCustomerFirstName}
                                    customerLastName={customerLastName}
                                    setCustomerLastName={setCustomerLastName}
                                    customerEmail={customerEmail}
                                    setCustomerEmail={setCustomerEmail}
                                    customerPhoneNumber={customerPhoneNumber}
                                    setCustomerPhoneNumber={setCustomerPhoneNumber}
                                    customerAdditionalInfo={customerAdditionalInfo}
                                    status={appointmentData?.status}
                                    goToNextPage={() => goToNextStep()}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    updateAppointmentStatusCustomer={(customerStatus: string) => updateAppointmentStatusCustomer(customerStatus)}
                                    getDataFromCustomer={(
                                        firstName,
                                        lastName,
                                        email,
                                        phoneNumber,
                                        additionalInfo
                                    ) => {
                                        getDataFromCustomer(
                                            firstName,
                                            lastName,
                                            email,
                                            phoneNumber,
                                            additionalInfo
                                        )
                                    }}
                                />
                            )
                        }
                        {
                            (!isTireChangeService && !isWheelChangeService && activeIndex === 2) && (
                                <Customer
                                    primaryKey={primaryKey}
                                    customerId={customerId}
                                    setCustomerId={setCustomerId}
                                    customerFirstName={customerFirstName}
                                    setCustomerFirstName={setCustomerFirstName}
                                    customerLastName={customerLastName}
                                    setCustomerLastName={setCustomerLastName}
                                    customerEmail={customerEmail}
                                    setCustomerEmail={setCustomerEmail}
                                    customerPhoneNumber={customerPhoneNumber}
                                    setCustomerPhoneNumber={setCustomerPhoneNumber}
                                    customerAdditionalInfo={customerAdditionalInfo}
                                    status={appointmentData?.status}
                                    goToNextPage={() => goToNextStep()}
                                    updateAppointmentStatusCustomer={(customerStatus: string) => updateAppointmentStatusCustomer(customerStatus)}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    getDataFromCustomer={(
                                        firstName,
                                        lastName,
                                        email,
                                        phoneNumber,
                                        additionalInfo
                                    ) => {
                                        getDataFromCustomer(
                                            firstName,
                                            lastName,
                                            email,
                                            phoneNumber,
                                            additionalInfo
                                        )
                                    }}

                                />
                            )
                        }
                        {
                            (isTireChangeService && !isWheelChangeService && activeIndex === 4) && (
                                <Invoice
                                    primaryKey={primaryKey}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    invoiceId={invoiceId}
                                    appointmentData={appointmentData}
                                    positions={prevSelectedPositions}
                                    allServices={allServices}
                                    goToNextPage={() => goToNextStep()}
                                />
                            )
                        }

                        {
                            (isTireChangeService && isWheelChangeService && activeIndex === 5) && (
                                <Invoice
                                    primaryKey={primaryKey}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    invoiceId={invoiceId}
                                    appointmentData={appointmentData}
                                    positions={prevSelectedPositions}
                                    allServices={allServices}
                                    goToNextPage={() => goToNextStep()}
                                />
                            )
                        }

                        {
                            (!isTireChangeService && isWheelChangeService && activeIndex === 4) && (
                                <Invoice
                                    primaryKey={primaryKey}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    invoiceId={invoiceId}
                                    appointmentData={appointmentData}
                                    positions={prevSelectedPositions}
                                    allServices={allServices}
                                    goToNextPage={() => goToNextStep()}
                                />
                            )
                        }



                        {
                            (!isTireChangeService && !isWheelChangeService && activeIndex === 3) && (
                                <Invoice
                                    primaryKey={primaryKey}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    invoiceId={invoiceId}
                                    appointmentData={appointmentData}
                                    positions={prevSelectedPositions}
                                    allServices={allServices}
                                    goToNextPage={() => goToNextStep()}
                                />
                            )
                        }
                        {
                            (isTireChangeService && !isWheelChangeService && activeIndex === 5) && (
                                <Payments
                                    primaryKey={primaryKey}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    invoiceData={appointmentData?.invoice}
                                    updateAppointmentPayment={updateAppointmentPayment}
                                    goToNextPage={() => goToNextStep()}
                                    appointmentData={appointmentData}

                                />
                            )
                        }

                        {
                            (isTireChangeService && isWheelChangeService && activeIndex === 6) && (
                                <Payments
                                    primaryKey={primaryKey}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    invoiceData={appointmentData?.invoice}
                                    updateAppointmentPayment={updateAppointmentPayment}
                                    goToNextPage={() => goToNextStep()}
                                    appointmentData={appointmentData}

                                />
                            )
                        }

                        {
                            (!isTireChangeService && isWheelChangeService && activeIndex === 5) && (
                                <Payments
                                    primaryKey={primaryKey}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    invoiceData={appointmentData?.invoice}
                                    updateAppointmentPayment={updateAppointmentPayment}
                                    goToNextPage={() => goToNextStep()}
                                    appointmentData={appointmentData}

                                />
                            )
                        }


                        {
                            (!isTireChangeService && !isWheelChangeService && activeIndex === 4) && (
                                <Payments
                                    primaryKey={primaryKey}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    invoiceData={appointmentData?.invoice}
                                    updateAppointmentPayment={updateAppointmentPayment}
                                    goToNextPage={() => goToNextStep()}
                                    appointmentData={appointmentData}
                                />
                            )
                        }

                        {
                            (isTireChangeService && !isWheelChangeService && activeIndex === 6) && (
                                <WorkOrder
                                    primaryKey={primaryKey}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    status={appointmentData?.status}
                                    appointmentWorkOrderId={workOrderId}
                                    updateAppointmentStatusWorkOrder={(workorderStatus: string) => updateAppointmentStatusWorkOrder(workorderStatus)}
                                    appointmentData={appointmentData}
                                    allServices={allServices}
                                />
                            )
                        }

                        {
                            (isTireChangeService && isWheelChangeService && activeIndex === 7) && (
                                <WorkOrder
                                    primaryKey={primaryKey}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    status={appointmentData?.status}
                                    appointmentWorkOrderId={workOrderId}
                                    updateAppointmentStatusWorkOrder={(workorderStatus: string) => updateAppointmentStatusWorkOrder(workorderStatus)}
                                    appointmentData={appointmentData}
                                    allServices={allServices}
                                />
                            )
                        }

                        {
                            (!isTireChangeService && isWheelChangeService && activeIndex === 6) && (
                                <WorkOrder
                                    primaryKey={primaryKey}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    status={appointmentData?.status}
                                    appointmentWorkOrderId={workOrderId}
                                    updateAppointmentStatusWorkOrder={(workorderStatus: string) => updateAppointmentStatusWorkOrder(workorderStatus)}
                                    appointmentData={appointmentData}
                                    allServices={allServices}
                                />
                            )
                        }

                        {
                            (!isTireChangeService && !isWheelChangeService && activeIndex === 5) && (
                                <WorkOrder
                                    primaryKey={primaryKey}
                                    setPleaseWaitPopup={setPleaseWaitPopup}
                                    status={appointmentData?.status}
                                    appointmentWorkOrderId={workOrderId}
                                    updateAppointmentStatusWorkOrder={(workorderStatus: string) => updateAppointmentStatusWorkOrder(workorderStatus)}
                                    appointmentData={appointmentData}
                                    allServices={allServices}
                                />
                            )
                        }
                    </div>
                </div>
            </div>
            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>

    )
}